module.exports = "<vb-autocomplete\r\n  #inputField\r\n  [items]=\"stockItemList\"\r\n  [loading]=\"loading\"\r\n  [control]=\"control\"\r\n  [searchFunction]=\"searchLabelAndArticleNumber\">\r\n\r\n  <ng-template let-stockItem=\"item\">\r\n    {{stockItem?.label}} ({{stockItem?.administration_unit?.label}})\r\n  </ng-template>\r\n\r\n</vb-autocomplete>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/stock-item/stock-item-input-field/stock-item-input-field.component.html
// module id = ./src/app/store-management/stock-item/stock-item-input-field/stock-item-input-field.component.html
// module chunks = main